(function() {
  var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  var ETSY_REVIEWS = 'https://www.etsy.com/shop/TheGrumpyUnicornCo?ref=condensed_trust_header_title_reviews#reviews';

  function cleanReviews() {
    document.querySelectorAll('.jdgm-rev__body').forEach(function(el) {
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
      var toRemove = [];
      var node;
      while ((node = walker.nextNode())) {
        if (/see original review on etsy/i.test(node.nodeValue) ||
            /view original etsy review/i.test(node.nodeValue)) {
          toRemove.push(node);
        }
      }
      toRemove.forEach(function(n) {
        var parent = n.parentNode;
        parent.removeChild(n);
        if (parent !== el && parent.textContent.trim() === '') {
          parent.parentNode && parent.parentNode.removeChild(parent);
        }
      });

      if (el.dataset.linkified) return;

      var walker2 = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
      var urlNodes = [];
      while ((node = walker2.nextNode())) {
        if (/etsy\.com/i.test(node.nodeValue)) urlNodes.push(node);
      }
      urlNodes.forEach(function(textNode) {
        if (textNode.parentNode.tagName === 'A') return;
        var span = document.createElement('span');
        span.innerHTML = textNode.nodeValue.replace(
          /(https?:\/\/[^\s<"]*etsy\.com[^\s<"]*|etsy\.com[^\s<"]*)/gi,
          function(url) {
            var href;
            if (isMobile) {
              return '';
            } else {
              var raw = url.startsWith('http') ? url : 'https://' + url;
              var pathPart = raw.replace(/^https?:\/\/(www\.)?etsy\.com/i, '');
              href = (pathPart && pathPart.length > 1) ? raw : ETSY_REVIEWS;
            }
            // href comes from third-party review text — encode quotes so it can't
            // break out of the attribute when written via innerHTML.
            href = String(href).replace(/"/g, '%22').replace(/'/g, '%27');
            return '<a href="' + href + '" target="_blank" rel="noopener" style="color:#c96b8a;text-decoration:underline;">View on Etsy</a>';
          }
        );
        textNode.parentNode.replaceChild(span, textNode);
      });
      el.dataset.linkified = '1';
    });
  }

  var attempts = 0;
  var interval = setInterval(function() {
    cleanReviews();
    attempts++;
    if (attempts > 20) clearInterval(interval);
  }, 500);

  var observer = new MutationObserver(cleanReviews);
  observer.observe(document.body, { childList: true, subtree: true });
})();